<template>
  <div class="download-page">
    <loading-overlay
      :visible="isDownloading"
      :inline="true"
      :label="$t('text.downloadPreparing')"
    />

    <p v-if="enabledUntil" class="download-copy">{{ $t('text.downloadAvailableUntil', this.$store.getters.patient ) }} {{ enabledUntil | moment("D MMMM YYYY") }} </p>
    <p v-if="this.$store.getters.user.hospital.downloadLicenseCostPerDay !== 0" class="download-copy">
      {{ $t('text.diaryPrice', { totalDownloadPrice: this.totalDownloadPrice } ) }}
      {{ $t('text.diaryPriceExplained', { totalDays: this.totalDays, downloadLicenseCostPerDay: this.downloadLicenseCostPerDay, maxDownloadPrice: this.maxDownloadPrice } ) }}
    </p>
    <p v-if="this.$store.getters.user.hospital.downloadLicenseCostPerDay !== 0" class="download-copy">
      {{ $t('text.diaryBankInfo' ) }}:<br>
      IBAN: BE39 7350 5877 5419<br>
      BIC: KREDBEBB
    </p>
    <p v-if="this.$store.getters.user.hospital.downloadLicenseCostPerDay === 0" class="download-copy">{{ $t('text.diaryFree' ) }}</p>

    <p class="download-notice">
      {{ $t('text.teVroegNotice') }} 
      <a href="https://www.tevroeg.be" target="_blank" rel="noopener noreferrer" class="download-notice-link">www.tevroeg.be</a>
    </p>

    <div class="download-checkbox">
      <v-checkbox class="d-inline-flex"
                  v-if="this.$store.getters.user.hospital.downloadLicenseCostPerDay !== 0"
                  v-model="termsAgreedTo"
                  :disabled="firstDownloadDate.length > 0"
                  :label="$t('checkbox.agreeToCost') + firstDownloadDate">
      </v-checkbox>
    </div>

    <div class="download-actions">
      <v-btn class="download-action" color="primary white--text" href="/">{{ $t('button.backToApp')}}</v-btn>
      <v-btn
        class="download-action"
        color="primary white--text"
        @click.prevent="exportPostData"
        :loading="isDownloading"
        :disabled="isDownloading || (!termsAgreedTo && this.$store.getters.user.hospital.downloadLicenseCostPerDay !== 0)"
      >{{ $t('button.downloadDiary')}}</v-btn>
    </div>
  </div>
</template>

<script>
import {neoparentPatients, neoparentDownloads} from "@/api";
import moment from "moment";

export default {
  name: "neoparent-download",
  props: ["enabled-until"],
  mounted() {
    this.getDownloadHistory()

    const createdDate = moment(this.$store.getters.patient.createdAt)
    const archivedDate = moment(this.$store.getters.patient.archivedAt)
    this.totalDays = archivedDate.diff(createdDate, 'days')
    this.totalDownloadPrice = this.totalDays * this.downloadLicenseCostPerDay

    if (this.downloadLicenseCostPerDay === 2) {
      this.maxDownloadPrice = 50
    } else if (this.downloadLicenseCostPerDay === 3) {
      this.maxDownloadPrice = 100
    }

    if (this.totalDownloadPrice > this.maxDownloadPrice) {
      this.totalDownloadPrice = this.maxDownloadPrice
      this.maxDownloadPriceReached = true
    }
  },
  data() {
    return {
      isDownloading: false,
      totalDownloadPrice: 0,
      termsAgreedTo: false,
      firstDownloadDate: "",
      maxDownloadPrice: 0,
      totalDays: 0,
      maxDownloadPriceReached: false,
      downloadLicenseCostPerDay: this.$store.getters.user.hospital.downloadLicenseCostPerDay
    };
  },
  methods: {
    exportPostData() {
      const that = this

      this.isDownloading = true

      neoparentPatients
        .getExportForPostData(that.$store.getters.user.language, that.$store.getters.user.patient.id)
        .then(result => {
          if (result.data.size !== 0){
            const url = window.URL.createObjectURL(result.data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', that.$t('app.settings.general.export-1a') + ' ' + that.$store.getters.user.patient.firstName + '.pdf');
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
          this.consoleLog(err);
        })
        .finally(() => {
          that.isDownloading = false
        });
    },
    getDownloadHistory() {
      const that = this

      neoparentDownloads
        .getDownloadHistory(that.$store.getters.user.patient.id, that.$store.getters.user.id)
        .then(result => {
          if (result && result.data && result.data[0]){
            that.firstDownloadDate = " -- "+ moment(result.data[0].createdAt).format("D MMMM YYYY")
            that.termsAgreedTo = true
          }
        })
    }
  }
}
</script>

<style scoped>
.download-page {
  position: relative;
  max-width: 760px;
  margin: 0 auto;
  padding: 0 12px 84px;
}

.download-copy {
  margin: 0 0 12px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.download-notice {
  border: 1px solid #00a9b3;
  border-radius: 4px;
  padding: 12px;
  margin: 16px 0;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.download-notice-link {
  color: #0000ee !important;
  text-decoration: underline !important;
}

.download-checkbox {
  display: flex;
  justify-content: center;
  margin: 12px 0;
}

.download-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.download-action {
  margin: 0 !important;
}

@media (max-width: 600px) {
  .download-page {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 94px;
  }

  .download-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .download-action {
    width: 100%;
  }
}

</style>
